/**
 * 一个单例的事件总线，用于一些跨组件通信的场景
 *
 * 要注意不应该滥用这个功能，否则代码的可读性会很低
 */
import mitt from 'mitt';
const eventBus = mitt();
export const EVENT = {
    workflowApprovalTimeout: 'workflow-approval-timeout', // 由当前审批单页面按需刷新展示状态
    updatePageContext: 'update-page-context', // 运行时页面会派发这个事件，页面创建 or 接受到 request 事件时，会把它的 wContext和 w 抛出来
    requestPageContext: 'request-page-context', // 主动去获取页面 Context
    updateDepLoaderState: 'update-dep-loader-state', // 监听依赖加载器的状态，由于引入了npm包的下载，整个依赖的引入过程会很慢，所以得用eventBus的方式监听
};
export default eventBus;
